import { createContext } from "react";

interface ContainerContextType {
  data?: Record<string, unknown>;
}

export const ContainerContext = createContext<ContainerContextType>({
  data: {}
});
